import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentRequestsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const getPaymentRequest = (paymentRequestId): any => action(types.GET_PAYMENT_REQUEST_REQUESTED, paymentRequestId);

export const getAllPaymentRequests = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENT_REQUESTS_REQUESTED, { pagination, compile });

export const selectPaymentRequest = (paymentRequestId): any => action(types.SELECT_PAYMENT_REQUEST_REQUESTED, {
  currentPaymentRequestId: paymentRequestId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  getPaymentRequestPending: (): any => action(types.GET_PAYMENT_REQUEST_PENDING, {}),
  getPaymentRequestSuccess: (response): any => action(types.GET_PAYMENT_REQUEST_SUCCESS, {
    paymentRequestsById: response.entities.paymentRequests,
    currentPaymentRequestId: response.result,
  }),
  getPaymentRequestFailed: (error): any => action(types.GET_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  getAllPaymentRequestsPending: (pagination): any => action(types.GET_ALL_PAYMENT_REQUESTS_PENDING, { pagination }),
  getAllPaymentRequestsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_REQUESTS_SUCCESS, {
    paymentRequestsById: response.entities.paymentRequests,
    paymentRequestIds: response.result,
    meta,
  }),
  getAllPaymentRequestsFailed: (error): any => action(types.GET_ALL_PAYMENT_REQUESTS_FAIL, { backendErrors: error }),
};

export default {
  getPaymentRequest,
  getAllPaymentRequests,
  selectPaymentRequest,
};
